export default {
  budgetDocuments: [],
};
